import { Controller } from "@hotwired/stimulus"
import {
  createLineChart,
  destroyChart,
  rateHistoryDatasets,
  percentLineOptions
} from "../modules/money_smart/chart_helpers"

export default class extends Controller {
  static targets = ["canvas"]

  static values = {
    labels: Array,
    values: Array,
    seriesLabel: { type: String, default: "Average rate" }
  }

  chart = null

  async connect() {
    if (!this.hasCanvasTarget) return
    if (this.valuesValue.length === 0) return

    const datasets = rateHistoryDatasets(this.seriesLabelValue, this.valuesValue)
    this.chart = await createLineChart(
      this.canvasTarget,
      this.labelsValue,
      datasets,
      percentLineOptions()
    )
  }

  disconnect() {
    destroyChart(this.chart)
    this.chart = null
  }
}
